// @ts-strict-ignore
import React from 'react'
import { Controller, UseFieldArrayProps } from 'react-hook-form'

import { IMaskMixin } from 'react-imask'
import TextInput from 'APP/Converse/Inputs/TextInput'
import { IconVariantProps } from 'APP/Converse/Icon/types'
import { baseColors } from 'APP/Theme/Theme'

interface ControllerDatePickerProps {
  control: UseFieldArrayProps['control']
  name: string
  rules?: UseFieldArrayProps['rules']
  testID?: string
  label: string
  isFocused?: boolean
  infotip?: string
  onFocus?: () => void
  disabled?: boolean
  placeholder?: string
  value?: string
  setValue: (name: string, value: string) => void
  onSelect: () => void
  showRequiredAsterisk?: boolean
  id?: string
  icon?: string
  iconVariant?: IconVariantProps
  iconColor?: keyof typeof baseColors
  iconSize?: number
  noBottomMargin?: boolean
}

const MaskedStyledInput = IMaskMixin(({ inputRef, ...props }) => (
  <TextInput {...props} ref={inputRef} />
))

const ControllerDatePicker = ({
  control,
  name,
  rules,
  testID,
  label,
  infotip,
  onFocus,
  disabled,
  placeholder,
  showRequiredAsterisk,
  onSelect,
  id,
  icon,
  iconVariant,
  iconColor,
  iconSize,
  noBottomMargin,
}: ControllerDatePickerProps) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
        <MaskedStyledInput
          mask="0000-00-00"
          maxLength={10}
          pattern="Y-m-dd"
          disabled={disabled}
          testID={testID}
          onAccept={onChange}
          value={value}
          onBlur={(e) => {
            onBlur(e)
            onSelect?.()
          }}
          onFocus={onFocus}
          returnKeyType="next"
          label={label}
          error={error?.message}
          keyboardType="default"
          infotip={infotip}
          placeholder={placeholder}
          showRequiredAsterisk={showRequiredAsterisk}
          id={id}
          icon={icon}
          iconVariant={iconVariant}
          iconColor={iconColor}
          iconSize={iconSize}
          noBottomMargin={noBottomMargin}
        />
      )}
    />
  )
}

export default ControllerDatePicker
